import React from 'react';
import KPIMonitoring from '../Monitoring/KPIMonitoring/KPIMonitoring';
import BranchManagerHeader from './BranchManagerHeader';
import { useTheme } from '../../contexts/ThemeContext';
import { useDomain, DOMAINS } from '../../contexts/DomainContext';
import './BranchManagerLayout.css';

const BranchManagerLayout = () => {
    const { theme } = useTheme();
    const { domain } = useDomain();

    const storedUser = localStorage.getItem('auth');
    const user = JSON.parse(storedUser);

    const isNGyeonggi = user.site === 'CLUS_NGYENGGI';

    return (
        <div
            className="branch-manager-layout"
            data-theme={theme}
            data-domain={domain}
        >
            <BranchManagerHeader />
            <div className="branch-manager-content">
                <KPIMonitoring
                    tabId="kpi-monitoring-branch"
                    isNGyeonggi={isNGyeonggi}
                />
            </div>
        </div>
    );
};

export default BranchManagerLayout;